module.exports = __webpack_public_path__ + "static/kesem-0-85e43f6834eebc5e9a10db7da867eb13.jpg";